import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('filter'),
    referenceFieldPlaceholder: defineMessage('enter_reference_2'),
    dateFieldTitle: defineMessage('creation_date_range'),
    fromFieldTitle: defineMessage('from_1'),
    toFieldTitle: defineMessage('to_1'),
    supplierFieldTitle: defineMessage('supplier'),
    referenceFieldTitle: defineMessage('reference'),
    amountLabel: defineMessage('total_amount_of_bills'),
    amountFieldTitle: defineMessage('amount_due_range'),
    plannedDateFieldTitle: defineMessage('planned_date_range'),
    dueDateFieldTitle: defineMessage('due_date_range'),
    resetButtonText: defineMessage('reset_filter'),
    applyButtonText: defineMessage('apply_filter'),
    excludeBillsWithZeroAmount: defineMessage('exclude_bills_reserved_within_another_batch'),
    totalAmountOfSelectedBills: defineMessage('total_amount_of_selected_bills_amount'),
};
